import React, { useEffect, useRef, useState } from "react";
import TrainerFilter from "../../../components/search-filter/components/trainer";
import PaymentMode from "../../../components/payment-mode";
import {getAllParameters} from '../../parameters/helper/api';
import { isAuthenticated } from "../../../auth";
import { formatDateTime, getTimeInAmPm, startLoader, stopLoader } from "../../../lib/utils";
import FlatPicker from 'flatpickr';
import Toast from "../../../lib/toast";
import { addExpense, updateExpense } from "../helper/api";
import GymFilter from "../../../components/gym-filter";
// import config from "../../../config";
import client from "../../../clients";
import '../style.scss';

let flatpickr;

const CreateExpense = (props) => {
  const [currentElementId, setCurrentElementId] = useState("");
  const [expense,setExpense] = useState({
    expenseName:"",
    expenseDate:"",
    expenseType:"",
    expenseAmount:"",
    recipientUser: "",
    paymentDetails:{
      paymentMode:"",
      paymentSource: "",
      cardType: "",
      bankName: "",
      upiId: "",
      mobileNumber: "",
      chequeNumber: "",
      transactionID: "",
      approvedCode: "",
      comment: ""
    },
    paymentReceipts: [],
    paidTo:{
      companyName:"",
      companyDesignation: ""
    }
  });
  const {expenseAmount,expenseName,expenseType,expenseDate,paidTo,paymentDetails,recipientUser} = expense;
  const [isExpenseTypeListOpen, setExpenseTypeListOpen] = useState(false);
  const [expenseTypes, setExpenseTypes] = useState([]);
  const {user,token} = isAuthenticated();
  const [isButtonLock,setButtonLock] = useState("");
  const [branch,setBranch] = useState('');
  const [selectedExpense,setSelectedExpense] = useState('');
  const isEditExpense = useRef(false);


  const getSelectedGym = gym =>{
    setBranch(gym);
  }

  const checkDataField = () =>{
    const isSalary = !`${expense.expenseType.includes("Salar")}`?(expense.paidTo.companyName && expense.paidTo.companyDesignation):expense.recipientUser;
    if(expense.expenseName && expense.expenseDate && expense.expenseAmount && expense.expenseType && expense.paymentDetails.paymentMode && (!isSalary?expense.paidTo.companyName:expense.recipientUser)){
      setButtonLock(false)
    }else{
      setButtonLock(true);
    }
  }

  const getRecipient = data =>{
    setExpense(oldstate=>{
      oldstate['recipientUser'] = data;
      return {...oldstate};
    })
  }

  const SaveExpense = async event =>{
    try{
      setButtonLock(true)
      await startLoader()
      
      const payload = {
        name:expenseName,
        amount:expenseAmount,
        paymentDate:{
            time:getTimeInAmPm(new Date(expenseDate)),
            date:new Date(expenseDate),
            formattedDate:formatDateTime(new Date(expenseDate))
        },
        paymentDetails:{
          paymentMode:paymentDetails.paymentMode,
          paymentSource:paymentDetails.paymentSource,
          cardType: paymentDetails.cardType,
          bankName:  paymentDetails.bankName,
          upiId:  paymentDetails.upiId,
          mobileNumber:  paymentDetails.mobileNumber,
          chequeNumber: paymentDetails.chequeNumber,
          transactionID:  paymentDetails.transactionID,
          approvedCode:  paymentDetails.approvedCode,
          comment:  paymentDetails.comment
        },
        paidTo:{
          companyName: paidTo.companyName,
          companyDesignation: paidTo.companyDesignation
        },
        gymId:branch.gymId,
        branchId:branch._id
      }

      const formData = new FormData();

      formData.set("name",payload.name);
      formData.set("amount",payload.amount);
      formData.set("paymentDate",JSON.stringify(payload.paymentDate));
      formData.set("paymentDetails",JSON.stringify(payload.paymentDetails));
      formData.set("paidTo",JSON.stringify(payload.paidTo));
      formData.set("gymId",payload.gymId);
      formData.set("branchId",payload.branchId);
      formData.set("expenseType",expense.expenseType);

      if(isEditExpense.current){
        let fileIDs = expense.paymentReceipts.filter(data=>data.file && data.file._id).map(data=>data.file._id);
        formData.set("paymentReceipts",JSON.stringify(fileIDs));
      }
      

      await Promise.all(expense.paymentReceipts.filter(data=>data.file && !data.file._id).map(data=>{
        formData.append('files',data.file);
      }));
      

      if(expenseType.includes("Salar")){
        formData.set("recipientUser",recipientUser._id)
      }

      const response = !isEditExpense.current?await addExpense(user._id,token,formData):await updateExpense(user._id,token,selectedExpense._id,formData);

      if(!response.error){
        new Toast({
          type:"success",
          duration:3000,
          message:"Expense created successfully"
        })
      }else{
        new Toast({
          type:"success",
          duration:100,
          message:response.error
        })
      }
      CloseExpense()
      props.reloadExpenseData();
      setButtonLock(false);
      await stopLoader()
    }catch(error){
      await stopLoader();
      setButtonLock(false)
    }
  }
 
  const handleExpenseDateDate = () => {
    flatpickr = FlatPicker("#date-select", {
      disableMobile: true,
      onChange: (e) => {
        setExpense({
          ...expense,
          expenseDate:e[0],
        })
      }
    })
    flatpickr.open();
  }
  
  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (id == 'expense-type') setExpenseTypeListOpen(!isExpenseTypeListOpen);
    if(id == "expense-date") {
      handleExpenseDateDate()
    }
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }
  }

  const handlePaidToChange = keyName => event =>{
    setExpense(oldtstate=>{
      oldtstate.paidTo[keyName] = event.target.value;
      return {...oldtstate};
    })
  }

  const handleChange = keyName => event => {
    setExpense(oldstate=>{
      if(keyName.includes(".")){
        oldstate[keyName.split('.')[0]][keyName.split('.')[1]]=event.target.value;
      }else{
        oldstate[keyName] = event.target.value;
      }
      return {...oldstate};
    })
  }

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const newReceipts = files.map((file) => {
      return {
        file,
        url:URL.createObjectURL(file)
      };
    });

    setExpense((prev) => ({
      ...prev,
      paymentReceipts: [...prev.paymentReceipts, ...newReceipts],
    }));
  };

  const handleSelectExpenseType = data => event => {
    setExpense({
      ...expense,
      expenseType:data.name
    })
  }

  const handlePaymentDetails = newPaymentDetails =>{
    setExpense({
      ...expense,
      paymentDetails:{
        ...paymentDetails,
        ...newPaymentDetails
      }
    })
  }


  const GetAllParameters = async () =>{
    try{
      let params = {
        noLimit: 'noLimit',
        sortByInstafit: "sort",
        type:"expenseType"
      }

      let response = await getAllParameters(user._id,token,params);

      if(!response.error){
        setExpenseTypes(response);
      }
    }catch(error){
      //
    }
  }

  const CloseExpense = () =>{
    if(props.closeEditExpense && props.selectedExpense) props.closeEditExpense();
    else if(props.toggleExpense()) props.toggleExpense();
  }

  const handleDeleteSelectedReceipt = (index) => {
    setExpense((prev) => ({
      ...prev,
      paymentReceipts: prev.paymentReceipts.filter((_, i) => i !== index),
    }));
  }

  useEffect(async ()=>{
   try{
    await startLoader()
    await GetAllParameters();
    await stopLoader()
   }catch(error){

   }
  },[])

  useEffect(async ()=>{
    if(props.selectedGym){
      setBranch(props.selectedGym);
    }
    if(props.selectedExpense){
      setSelectedExpense(props.selectedExpense);
    }
    isEditExpense.current = (props.closeEditExpense && props.selectedExpense)?true:false;

    if(props.selectedExpense){
      const paymentReceipts =[];
      if(props.selectedExpense.paymentReceiptFiles){
        await Promise.all(props.selectedExpense.paymentReceiptFiles.map(file=>{
          paymentReceipts.push({
            file:file,
            url:`${client.config.API_URL}/image/file/${file._id}/auto/auto/70`
          });
        }));
      }
      setExpense({
        ...expense,
        expenseName:props.selectedExpense.name,
        expenseDate:props.selectedExpense.paymentDate.date,
        expenseType:props.selectedExpense.expenseType,
        expenseAmount:props.selectedExpense.amount,
        recipientUser: props.selectedExpense.recipientUserData[0],
        paymentDetails:{
          paymentMode:props.selectedExpense.paymentDetails.paymentMode,
          paymentSource: props.selectedExpense.paymentDetails.paymentSource,
          cardType: props.selectedExpense.paymentDetails.cardType,
          bankName: props.selectedExpense.paymentDetails.bankName,
          upiId: props.selectedExpense.paymentDetails.upiId,
          mobileNumber: props.selectedExpense.paymentDetails.mobileNumber,
          chequeNumber: props.selectedExpense.paymentDetails.chequeNumber,
          transactionID: props.selectedExpense.paymentDetails.transactionID,
          approvedCode: props.selectedExpense.paymentDetails.approvedCode,
          comment: props.selectedExpense.paymentDetails.comment
        },
        paymentReceipts,
        paidTo:{
          companyName: props.selectedExpense.paidTo.companyName,
          companyDesignation: props.selectedExpense.paidTo.companyDesignation
        }
      })
    }
  },[props]);

  useEffect(()=>{
    checkDataField();
  },[expense]);

  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container d-flex flex-item">
        <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "79%" : "100%"}}>
          
          {
            window.innerWidth > 767 && (
              <div className="d-flex w-full space-between m-b-16" style={{background: "#DEF3FF", padding:"12px", borderRadius: "16px 16px 0 0"}}>
                <div className='d-flex'>
                  <svg className='flex-item m-r-8' width="30" height="30" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.7507 17.5H7.00065C4.80032 17.5 3.70132 17.5 3.01765 16.8163C2.33398 16.1327 2.33398 15.0337 2.33398 12.8333V8.16667C2.33398 5.96633 2.33398 4.86733 3.01765 4.18367C3.70132 3.5 4.80032 3.5 7.00065 3.5H21.0007C23.201 3.5 24.3 3.5 24.9836 4.18367C25.6673 4.86733 25.6673 5.96633 25.6673 8.16667V14C25.6673 15.0873 25.6673 15.631 25.49 16.0592C25.3727 16.3425 25.2008 16.5999 24.984 16.8167C24.7672 17.0335 24.5098 17.2054 24.2265 17.3227C23.7983 17.5 23.2547 17.5 22.1673 17.5" stroke="var(--darkBlue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.1667 19.8327C15.1667 18.9044 15.5354 18.0142 16.1918 17.3578C16.8482 16.7014 17.7384 16.3327 18.6667 16.3327V13.9993C18.6667 13.0711 19.0354 12.1809 19.6918 11.5245C20.3482 10.8681 21.2384 10.4993 22.1667 10.4993V16.916C22.1667 19.6402 22.1667 21.0017 21.616 22.033C21.1809 22.847 20.5143 23.5136 19.7003 23.9487C18.669 24.4993 17.3075 24.4993 14.5833 24.4993H14C11.8253 24.4993 10.738 24.4993 9.88167 24.1435C9.3153 23.9093 8.80063 23.5657 8.36705 23.1325C7.93346 22.6993 7.58945 22.185 7.35467 21.6188C7 20.7613 7 19.674 7 17.4993M16.3333 10.4993C16.3333 11.1182 16.0875 11.7117 15.6499 12.1493C15.2123 12.5868 14.6188 12.8327 14 12.8327C13.3812 12.8327 12.7877 12.5868 12.3501 12.1493C11.9125 11.7117 11.6667 11.1182 11.6667 10.4993C11.6667 9.88051 11.9125 9.28702 12.3501 8.84943C12.7877 8.41185 13.3812 8.16602 14 8.16602C14.6188 8.16602 15.2123 8.41185 15.6499 8.84943C16.0875 9.28702 16.3333 9.88051 16.3333 10.4993Z" stroke="var(--darkBlue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <p className="flex-item modal-header-text">{isEditExpense.current?"Edit Expense":"Create Expense"}</p>
                </div>
                <div onClick={()=>CloseExpense()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                  <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                  </svg>
                </div>
              </div>
            )
          }
          <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ padding: window.innerWidth > 767 ? "0 12px" : "12px" }}>
            <div className="w-full m-b-12">
              <GymFilter filterSection="gym-filter" featureGymFilter={true} getSelectedGym={getSelectedGym} selectedGym={branch} />
            </div>
            <div className="d-flex w-full space-between m-b-12">
              
              <div onClick={toggleInputFields('expense-name')} className={`${(currentElementId == 'expense-name' || expenseName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'expense-name' || expenseName) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'expense-name' || expenseName) ? "10px" : "14px", color: (currentElementId == 'expense-name' || expenseName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Expense Name</p>
                </div>
                <input value={expenseName} onChange={handleChange("expenseName")} style={{color: expenseName ? "#5d883c" : expenseName ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'expense-name' || expenseName) ? "active-input-field" : "inactive-input-field"}`} type="text" />
              </div>

              <div id="date-select" onClick={toggleInputFields('expense-date')} className={`${(currentElementId == 'expense-date' || expenseDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'expense-date' || expenseDate) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'expense-date' || expenseDate) ? "10px" : "14px", color: (currentElementId == 'expense-date' || expenseDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Expense Date</p>
                </div>
                <input value={formatDateTime(expenseDate)} style={{color: expenseDate ? "#5d883c" : expenseDate ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'expense-date' || expenseDate) ? "active-input-field" : "inactive-input-field"}`} disabled />
              </div>
              
            </div>

            <div className="d-flex w-full space-between m-b-12">

              <div onClick={toggleInputFields('expense-amount')} className={`${(currentElementId == 'expense-amount' || expenseAmount) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'expense-amount' || expenseAmount) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'expense-amount' || expenseAmount) ? "10px" : "14px", color: (currentElementId == 'expense-amount' || expenseAmount) ? "var(--darkBlue)" : "", transition: "180ms" }}>Amount</p>
                </div>
                <input value={expenseAmount} onChange={handleChange("expenseAmount")} style={{color: expenseAmount ? "#5d883c" : expenseAmount ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'expense-amount' || expenseAmount) ? "active-input-field" : "inactive-input-field"}`} type="number" />
              </div>

              <div onClick={toggleInputFields('expense-type')} className={`${(currentElementId == "expense-type" || expenseType) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "expense-type" || expenseType) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "expense-type" || expenseType) ? "10px" : "14px", color: (currentElementId == "expense-type" || expenseType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Expense Type</p>
                </div>
                <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                  <svg className="flex-item" style={{ transform: isExpenseTypeListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                  </svg>
                </div>
                <input id="expense-type" className={`${(currentElementId == "expense-type" || expenseType) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select" value={expenseType} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
                {
                  isExpenseTypeListOpen && (
                    <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                      {
                        expenseTypes.map(data=>{
                          return (
                            <div onClick={handleSelectExpenseType(data)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item" style={{textTransform:'capitalize'}}>{data.name}</p>
                            </div>
                          );
                        })
                      }
                    </div>
                  )
                }
              </div>              
            </div>

            <p className="flex-item font-weight-700 color-dark-blue m-t-20 m-b-8">Paid To</p>
            
            {
              expenseType == "Salaries & Wages" ? (
                <TrainerFilter recipientUser={recipientUser} getRecipient={getRecipient} selectedGym={branch} />
              ) : (
                <div className="d-flex space-between">
                  <div onClick={toggleInputFields('company-name')} className={`${(currentElementId == 'company-name' || paidTo.companyName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'company-name' || paidTo.companyName) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'company-name' || paidTo.companyName) ? "10px" : "14px", color: (currentElementId == 'company-name' || paidTo.companyName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Company Name</p>
                    </div>
                    <input value={paidTo.companyName} onChange={handlePaidToChange("companyName")} style={{color: paidTo.companyName ? "#5d883c" : paidTo.companyName ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'company-name' || paidTo.companyName) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>

                  <div onClick={toggleInputFields('company-designation')} className={`${(currentElementId == 'company-designation' || paidTo.companyDesignation) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'company-designation' || paidTo.companyDesignation) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'company-designation' || paidTo.companyDesignation) ? "10px" : "14px", color: (currentElementId == 'company-designation' || paidTo.companyDesignation) ? "var(--darkBlue)" : "", transition: "180ms" }}>Designation</p>
                    </div>
                    <input value={paidTo.companyDesignation} onChange={handlePaidToChange("companyDesignation")} style={{color: paidTo.companyDesignation ? "#5d883c" : paidTo.companyDesignation ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'company-designation' || paidTo.companyDesignation) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>
                </div>
              )
            }

            <PaymentMode paymentDetails={paymentDetails} handlePaymentDetails={handlePaymentDetails}/>
            
            <p className="flex-item font-weight-700 color-dark-blue m-t-20 m-b-8">Payment Receipt</p>

            <div className="d-flex-wrap w-full">
              {
                expense.paymentReceipts.length>0 && expense.paymentReceipts.map((receipt, index)=>{
                  return(
                    <div className="payment-receipt m-r-12 m-b-12 d-flex">
                      <img className="flex-item payment-receipt-image" src={receipt.url} />
                      <div onClick={()=>handleDeleteSelectedReceipt(index)} className="delete-receipt-button bg-white d-flex">
                        <svg className="flex-item margin-auto svg-stroke" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.4375 11.875L11.5625 3.75M11.5625 11.875L3.4375 3.75" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  )
                })
              }
              <div className="payment-receipt flex-item d-flex m-b-12" style={{width: expense.paymentReceipts.length > 0 ? "92px" : "100%", height: expense.paymentReceipts.length == 0 && "114px",position:'relative'}}>
                {
                  expense.paymentReceipts.length === 0 ? (
                    <svg className="payment-input-box flex-item" width="100%" height="auto" viewBox="0 0 349 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="348" height="91" rx="10.5" fill="white" stroke="#C3C3C3" stroke-dasharray="4 4"/>
                    </svg>
                  ) : (
                    <svg className="payment-input-box flex-item" width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="91" height="91" rx="10.5" fill="white" stroke="black" stroke-dasharray="4 4"/>
                    </svg>
                  )
                }
                <div className="d-flex margin-auto flex-item" style={{zIndex:"2"}}>
                  <svg className="flex-item" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.68421 0.5H38.8158C40.7212 0.5 42.5485 1.25691 43.8958 2.60421C45.2431 3.95151 46 5.77884 46 7.68421V38.8158C46 40.7212 45.2431 42.5485 43.8958 43.8958C42.5485 45.2431 40.7212 46 38.8158 46H7.68421C5.77884 46 3.95151 45.2431 2.60421 43.8958C1.25691 42.5485 0.5 40.7212 0.5 38.8158V7.68421C0.5 5.77884 1.25691 3.95151 2.60421 2.60421C3.95151 1.25691 5.77884 0.5 7.68421 0.5ZM7.68421 2.89474C6.41396 2.89474 5.19574 3.39934 4.29754 4.29754C3.39934 5.19574 2.89474 6.41396 2.89474 7.68421V35.4392L13.1682 25.1418L19.155 31.1287L31.1287 19.155L43.6053 31.6316V7.68421C43.6053 6.41396 43.1007 5.19574 42.2025 4.29754C41.3043 3.39934 40.086 2.89474 38.8158 2.89474H7.68421ZM19.155 34.5292L13.1682 28.5424L2.89474 38.8158C2.89474 40.086 3.39934 41.3043 4.29754 42.2025C5.19574 43.1007 6.41396 43.6053 7.68421 43.6053H38.8158C40.086 43.6053 41.3043 43.1007 42.2025 42.2025C43.1007 41.3043 43.6053 40.086 43.6053 38.8158V35.0082L31.1287 22.5555L19.155 34.5292ZM13.6711 7.68421C15.2589 7.68421 16.7816 8.31497 17.9044 9.43772C19.0271 10.5605 19.6579 12.0832 19.6579 13.6711C19.6579 15.2589 19.0271 16.7816 17.9044 17.9044C16.7816 19.0271 15.2589 19.6579 13.6711 19.6579C12.0832 19.6579 10.5605 19.0271 9.43772 17.9044C8.31497 16.7816 7.68421 15.2589 7.68421 13.6711C7.68421 12.0832 8.31497 10.5605 9.43772 9.43772C10.5605 8.31497 12.0832 7.68421 13.6711 7.68421ZM13.6711 10.0789C12.7184 10.0789 11.8047 10.4574 11.131 11.131C10.4574 11.8047 10.0789 12.7184 10.0789 13.6711C10.0789 14.6237 10.4574 15.5374 11.131 16.2111C11.8047 16.8847 12.7184 17.2632 13.6711 17.2632C14.6237 17.2632 15.5374 16.8847 16.2111 16.2111C16.8847 15.5374 17.2632 14.6237 17.2632 13.6711C17.2632 12.7184 16.8847 11.8047 16.2111 11.131C15.5374 10.4574 14.6237 10.0789 13.6711 10.0789Z" fill="#8D8D8D"/>
                  </svg>
                  {
                    expense.paymentReceipts.length === 0 && (
                      <p className="flex-item fs-16 font-weight-600 m-l-12">Upload Payment Proof</p>
                    )
                  }
                </div>
                <input type="file" onChange={handleFileChange} className="w-full h-full" accept=".png, .jpg, .jpeg" style={{zIndex:"3"}} multiple/>
              </div>
            </div>

            <div className="w-full" style={{position:"absolute", bottom:0, left:0, padding:"12px"}}>
              <div onClick={isButtonLock?null:SaveExpense} className={`global-button-container ${isButtonLock ?"global-button-container-inactive":'global-button-container-active'} m-t-16 d-flex flex-item`} style={{borderRadius:"20px", height:"40px"}}>
                <p className="flex-item">{isEditExpense.current?"Update Expense":"Create Expense"}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateExpense;